module.exports = __webpack_public_path__ + "static/logo-light-mobil-1c272859d2d8a90ac7e93e467ecd082a.png";